import React from 'react';
import styled from 'styled-components';

import theme from 'styles/theme';

const SkillRating = styled.div`
  display: grid;
  grid-template-columns: 1fr 4fr;
  align-items: center;
  line-height: 1;
  margin: 0 0 8px;

  &:last-child {
    margin: 0;
  }

  @media screen and (max-width: 850px) {
    grid-template-columns: 1fr 2fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 35% 65%;
  }

  @media screen and (max-width: 500px) {
    grid-template-columns: 25px 1fr;
  }

  .SkillRating__icon {
    width: 20px;
    height: auto;
    margin-right: 5px;
  }

  .SkillRating__header {
    display: flex;
    font-size: 20px;
    font-weight: 700;
    flex-flow: row nowrap;
    align-items: center;

    @media screen and (max-width: 600px) {
      font-size: 16px;
    }

    @media screen and (max-width: 500px) {
      font-size: 0;
    }
  }

  .SkillRating__progress {
    position: relative;
    height: 10px;
    background: ${theme.B400};
    box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);

    &-bar {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      background: ${theme.A900};
      width: ${props => props.rating / 10 * 100 + '%'};
    }
  }
`;

export default props => {
  return (
    <SkillRating rating={props.rating}>
      {props.header && (
        <div className="SkillRating__header">
          {props.icon && <img className="SkillRating__icon" src={props.icon} alt={props.title} />}
          {props.header}
        </div>
      )}
      <div className="SkillRating__progress">
        <div className="SkillRating__progress-bar" />
      </div>
    </SkillRating>
  );
};



// WEBPACK FOOTER //
// ./src/components/Skill/SkillRating.js